import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import {BassType} from "../../../models/BassType";
import CheckboxFilter from "./CheckboxFilter";

export default observer(function BassTypeFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const { filteredBassType, setFilteredBassType } = AccordionStore;
    const { currentLanguageMessages } = LanguageStore

    return (
        <CheckboxFilter
            title={currentLanguageMessages.AccordionsPage.Filter.BassType.title}
            filteredValue={filteredBassType}
            setFilteredValue={setFilteredBassType}
            checkObjects={[
                {value: BassType.Standard, label: currentLanguageMessages.AccordionsPage.Filter.BassType.standard},
                {value: BassType.Convertor, label: currentLanguageMessages.AccordionsPage.Filter.BassType.convertor}
            ]}
            attributeName={'bassType'}
        />
    )
})